// extracted by mini-css-extract-plugin
export default {"top":"Form_top__bRNXE","title":"Form_title__NtaJz","info":"Form_info__wuJ8Q","button":"Form_button__+3INS","foot":"Form_foot__1UzEm","link":"Form_link__8TdO7"};